<input type="text" #input [value]="controlDir.control.value" (input)="onChange($event.target.value)"
  (blur)="onTouched()" [disabled]="disabled" class="input" [ngClass]="{
    error: !controlDir.control.valid && controlDir.control.touched,
    success: controlDir.control.valid && controlDir.control.touched
  }" />

<span class="error-msg" *ngIf="controlDir && !controlDir.control.valid && controlDir.control.touched">
  {{
  controlDir.control.errors.required
  ? 'O preenchimento desse campo é obrigatório.'
  : 'Por favor insira um email válido.'
  }}
</span>